import type { AxiosError, AxiosInstance } from 'axios';
import axios from 'axios';
import { coreApiBasePath } from './apiBasePath';

export interface VueAxios extends AxiosInstance {
  isAxiosError(payload: any): payload is AxiosError;
}

const http = axios.create({
  withCredentials: true,
  xsrfCookieName: 'PODOS-XSRF-TOKEN',
  xsrfHeaderName: 'X-CSRF-TOKEN',
  baseURL: coreApiBasePath(),
  headers: {
    'Content-Type': 'application/json',
  },
}) as VueAxios;

http.isAxiosError = axios.isAxiosError;

export { http };
